module.exports = __webpack_public_path__ + "static/WEDDING E&M-510-579ec8dab120de2cfab705eca1809324.jpg";